export const HOME_PATH: string = "/";
export const PROFESSIONS_PATH: string = "/profili-professionali";
export const SCHOOLS_PATH: string = "/informativa";
export const USERS_PATH: string = "/utente";

export const NEW_PATH: string = "/new";
export const SEARCH_PATH: string = "/search";
